import * as yup from "yup";

export const validationSettingSchema = yup.object({
    // codePrefix: yup
    //     .string()
    //     .required("Required"),
    // codeSuffix: yup
    //     .string()
    //     .required("Required"),
})

export const validationSchema = yup.object({
    uomId: yup
        .string()
        .required("Required"),
    code: yup
        .string()
        .required("Required"),
    // displayCode: yup
    //     .string()
    //     .required('Required'),
    // supplierId: yup.array()
    //     .of(yup.string())
    //     .min(1, "Min 1 selection")
    //     .required('Required'),
    // uomDesc: yup
    //     .string()
    //     .required("Required"), 
    cost: yup
        .number()
        .typeError("Number Only")
        .required("Required"),

    uomPrice: yup
        .number()
        .typeError("Number Only")
        .required("Required"),
    // floorPrice: yup
    //     .number()
    //     .typeError("Number Only")
    //     .required("Required"),
    // volumeWeight: yup
    //     .number()
    //     .typeError("Number Only")
    //     .required("Required"),
    // grossWeight: yup
    //     .number()
    //     .typeError("Number Only")
    //     .required("Required"),
    // netWeight: yup
    //     .number()
    //     .typeError("Number Only")
    //     .required("Required"),
    // width: yup
    //     .number()
    //     .typeError("Number Only")
    //     .required("Required"),
    // height: yup
    //     .number()
    //     .typeError("Number Only")
    //     .required("Required"),
    // length: yup
    //     .number()
    //     .typeError("Number Only")
    //     .required("Required"),
    // cbm: yup
    //     .number()
    //     .typeError("Number Only")
    //     .required("Required"),
    transformRatio: yup
        .number()
        .typeError("Number Only")
        .min(1, "Min Ratio 1")
        .required("Required"),
    // relocateThresholdQty: yup
    //     .number()
    //     .typeError("Number Only")
    //     .required("Required"),
    // reorderThresholdQty: yup
    //     .number()
    //     .typeError("Number Only")
    //     .required("Required"),
    // relocateTopUpQty: yup
    //     .number()
    //     .typeError("Number Only")
    //     .required("Required"),
    // reorderTopUpQty: yup
    //     .number()
    //     .typeError("Number Only")
    //     .required("Required"),
})


export const validationSchemaRow = yup.object({
    customFieldId: yup
        .string()
        .required('Required'),
    // customValue: yup
    //     .string()
    //     .required('Required')
})

export const validationSchemaRows = yup.object({
    rows: yup.array().of(validationSchemaRow)
})

export const initialSettingValues = {
    codePrefix: "",
    codeSuffix: "",
    showCbm: false,
}

export const initialValuesRow = {
    customFieldId: "",
    customValue: "",
    customArray: []
}
export const initialValues = {
    uomId: "",
    code: "",
    // displayCode:"",
    supplierId: [],

    uomDesc: "",
    remark: "",
    repackRemark: "",
    cost: "",
    uomPrice: "",

    floorPrice: "",
    volumeWeight: "",
    grossWeight: "",
    netWeight: "",
    width: "",

    height: "",
    length: "",
    cbm: "",

    relocateTopUpQty: "",
    relocateThresholdQty: "",
    reorderTopUpQty: "",
    reorderThresholdQty: "",

    transformRatio: "0",

    packageStatus: false,
    uomStatus: true,

    rows: [initialValuesRow]
}
